import { Box } from "@mui/material";
import React from "react";

const PDFViewer = ({ path }) => {
  return (
    <Box width="100%" height="100%" sx={{ borderRadius: "20px" }}>
      <object
        data={path}
        type="application/pdf"
        width="100%"
        height="100%"
        style={{ borderRadius: "20px" }}
      >
        <p>
          View not available. <a href={path}>Click here</a> to see.
        </p>
      </object>
    </Box>
  );
};
export default PDFViewer;
